// src/contexts/UserContext.jsx
import { createContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../services/firebase";

export const UserContext = createContext();

export function UserProvider({ children }) {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        if (!user) {
          setUserInfo(null);
          return;
        }

        const snap = await getDoc(doc(db, "users", user.uid));
        const data = snap.exists() ? snap.data() : {};

        setUserInfo({
          uid: user.uid,
          email: user.email,
          role: data.role || null,
          displayName: data.displayName || data.name || data.driverName || "",
          position: data.position || data.jobTitle || "",
          companyId: data.companyId || "",
          companyIds: Array.isArray(data.companyIds) ? data.companyIds : [],
        });
      } catch (error) {
        console.error("Failed to load user profile:", error);
        setUserInfo(
          user
            ? {
                uid: user.uid,
                email: user.email,
                role: null,
                displayName: user.displayName || "",
                position: "",
                companyId: "",
                companyIds: [],
              }
            : null,
        );
      } finally {
        setIsLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={{ userInfo, isLoading }}>
      {children}
    </UserContext.Provider>
  );
}
